import { startCase } from 'lodash';

export const statusDefs: Record<string, { label: string }> = {
  DRAFT: { label: 'Draft' },
  PICKING: { label: 'Picking' },
  PAID: { label: 'Paid' },
  SUBMITTED: { label: 'Submitted' },
  READY: { label: 'Ready' },
  ERROR: { label: 'Error' },
  CLOSED: { label: 'Closed' },
  CANCELLED: { label: 'Cancelled' },
  IN_TRANSIT: { label: 'In Transit' },
  SHIPPED: { label: 'Shipped' },
  PENDING_LIQUIDATION: { label: 'Liquidation' },
  IN_PROGRESS: { label: 'In Progress' },
  MID_PRODUCTION_RUN: { label: 'Mid Production Run' },
  MID_RECEIVING: { label: 'Mid Receiving' },
  RECEIVING: { label: 'Receiving' },
  RECEIVED: { label: 'Received' },
  NEEDS_INFO: { label: 'Needs Info' },
  CONFIRMED: { label: 'Confirmed' },
  OPEN: { label: 'Open' },
  NOT_STARTED: { label: 'Not Started' },
  PARTIALLY_PICKED: { label: 'Picked Partially' },
  FULLY_PICKED: { label: 'Picked Fully' },
  PARTIALLY_RECEIVED: { label: 'Received Partially' },
  FULLY_RECEIVED: { label: 'Received Fully' },
  PAID_FULL: { label: 'Paid Full' },
  PAID_PARTIAL: { label: 'Paid Partially' },
  VOIDED: { label: 'Voided' },
  FINALIZED: { label: 'Finalized' },
  PAYMENT_RECONCILIATION: { label: 'Payment Reconciliation' },
  PENDING_SETTLEMENT: { label: 'Pending Settlement' },
  PROCESSING_ERROR: { label: 'Processing Error' },
  LOCKED: { label: 'Locked' },
  COMPLETE: { label: 'Complete' },
  BOOKED: { label: 'Booked' },
  EN_ROUTE: { label: 'En Route' },
  PRINTED: { label: 'Printed' },
  TEMPLATE: { label: 'Template' },
  FLAGGED: { label: 'Flagged' },
  APPROVED: { label: 'Approved' },
  PENDING: { label: 'Pending' },
  REJECTED: { label: 'Locked' },
  INVOICED: { label: 'Invoiced' },
  warning: { label: 'Warning' },
};

export const getStatusLabel = (status: string): string => statusDefs[status]?.label ?? startCase(status.toLowerCase());
